import { http } from './http';

export function getPublicProfile(username) {
  return http.get(`/api/v1/users/${encodeURIComponent(username)}`).then((r) => r.data);
}

export function getPublicActivity(username, params = {}) {
  const search = new URLSearchParams();
  if (params.type) search.set('type', params.type);
  if (params.page) search.set('page', String(params.page));
  if (params.limit) search.set('limit', String(params.limit));
  const q = search.toString();
  return http.get(`/api/v1/users/${encodeURIComponent(username)}/activity${q ? `?${q}` : ''}`).then((r) => r.data);
}

export function followUser(username) {
  return http.post(`/api/v1/users/${encodeURIComponent(username)}/follow`).then((r) => r.data);
}

export function unfollowUser(username) {
  return http.delete(`/api/v1/users/${encodeURIComponent(username)}/follow`).then((r) => r.data);
}

export function reportUser(username, reason) {
  return http.post(`/api/v1/users/${encodeURIComponent(username)}/report`, { reason }).then((r) => r.data);
}

export function getFollowers(username, page = 1) {
  return http
    .get(`/api/v1/users/${encodeURIComponent(username)}/followers?page=${page}`)
    .then((r) => r.data);
}

export function getFollowing(username, page = 1) {
  return http
    .get(`/api/v1/users/${encodeURIComponent(username)}/following?page=${page}`)
    .then((r) => r.data);
}
